import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';

@Component({
    selector: 'contact-component',
    templateUrl: './contact.component.html',
    standalone: false
})
export class ContactComponent {
  links: any[] = [];

  constructor(private http: HttpClient) { }

}
